import { useState, useRef } from 'react';
import { useButton } from '@react-aria/button';
import I18n from 'I18n';
import styled from 'styled-components';
import VizExImage from 'visitor-ui-component-library/image/VizExImage';
import VizExLoadingSpinner from 'visitor-ui-component-library/loading/VizExLoadingSpinner';
import MediaCaption from './MediaCaption';
import BaseMediaWrapper from './MediaWrapper';
import ThumbnailButton from './ThumbnailButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CardContainer = styled.div.withConfig({
  displayName: "ImageCard__CardContainer"
})(["max-width:360px;"]);
const MediaWrapper = styled(BaseMediaWrapper).withConfig({
  displayName: "ImageCard__MediaWrapper"
})(["max-width:360px;"]);
const LoadingPlaceholder = styled.div.withConfig({
  displayName: "ImageCard__LoadingPlaceholder"
})(["width:100%;aspect-ratio:16 / 9;display:flex;align-items:center;justify-content:center;background:", ";"], ({
  theme
}) => {
  var _theme$spotlight$colo;
  return (_theme$spotlight$colo = theme.spotlight.color.surfaceAlt) !== null && _theme$spotlight$colo !== void 0 ? _theme$spotlight$colo : '#f5f8fa';
});
const HiddenWhileLoading = styled.div.withConfig({
  displayName: "ImageCard__HiddenWhileLoading"
})(["", ""], ({
  $loaded
}) => !$loaded && `
    position: absolute;
    opacity: 0;
    pointer-events: none;
  `);
const ImageCard = ({
  fileMetadata,
  onPress
}) => {
  const {
    url,
    displayName: name
  } = fileMetadata;
  const [loaded, setLoaded] = useState(false);
  const buttonRef = useRef(null);
  const {
    buttonProps
  } = useButton({
    onPress
  }, buttonRef);
  return /*#__PURE__*/_jsxs(CardContainer, {
    children: [/*#__PURE__*/_jsxs(MediaWrapper, {
      children: [!loaded && /*#__PURE__*/_jsx(LoadingPlaceholder, {
        children: /*#__PURE__*/_jsx(VizExLoadingSpinner, {
          size: "sm"
        })
      }), /*#__PURE__*/_jsx(HiddenWhileLoading, {
        $loaded: loaded,
        children: /*#__PURE__*/_jsx(ThumbnailButton, Object.assign({}, buttonProps, {
          ref: buttonRef,
          "aria-label": I18n.text('conversations-visitor-ui.spotlight.lightbox.viewImage', {
            name
          }),
          children: /*#__PURE__*/_jsx(VizExImage, {
            src: url,
            alt: name,
            style: {
              width: '100%',
              height: 'auto'
            },
            onLoad: () => setLoaded(true),
            onError: () => setLoaded(true)
          })
        }))
      })]
    }), /*#__PURE__*/_jsx(MediaCaption, {
      title: name,
      children: name
    })]
  });
};
ImageCard.displayName = 'ImageCard';
export default ImageCard;